import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityMaintainanceUserDetailsObject, FacilitySummaryObject } from 'src/app/core/services/facility.model';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { GetFacilityInfoByEmailService } from 'src/app/pre-login/services/get-facility-info-by-email.service';

@Component({
  selector: 'app-information-form',
  templateUrl: './information-form.component.html',
  styleUrls: ['./information-form.component.scss'],
})
export class InformationFormComponent implements OnInit {
  rootScopeData: RootScopeDeclare;

  displayStep: number;
  step1Info: FacilityMaintainanceUserDetailsObject;
  step2Info: FacilitySummaryObject;
  managerParam: string | null;
  showModal = false;
  action: string = '';

  constructor(
    private rootScopeService: RootScopeService,
    private commonUtil: CommonUtil,
    private route: ActivatedRoute,
    private router: Router,
    private getFacilityInfo: GetFacilityInfoByEmailService
  ) {
    this.getRootScopeData();
  }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.action = data['action'];
    });
    
    // this.getFacilityInfo.getFacilityInformationByEmail(this.managerParam).subscribe(
    //   (data) => {
    //     this.step2Info = data.facility;
    //     this.step1Info = data.user;
    //     this.showStep1();
    //   },
    //   (error) => {
    //     delete this.managerParam;
    //     this.showStep1();
    //     console.error('API error.');
    //   }
    // );

    this.showStep2();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  scrollToStepper(): void {
    const elmnt = <HTMLElement>document.getElementById('stepper-cntr');
    elmnt.scrollIntoView({ behavior: 'smooth' });
  }

  showStep1() {
    this.displayStep = 1;
    // this.scrollToStepper();
    this.commonUtil.scrollTop();
  }

  showStep2() {
    this.displayStep = 2;
    // this.scrollToStepper();
    this.commonUtil.scrollTop();
  }

  showStep3() {
    this.displayStep = 3;
    // this.scrollToStepper();
    this.commonUtil.scrollTop();
  }

  step1DataHandler(step1Data: FacilityMaintainanceUserDetailsObject): void {
    this.step1Info = step1Data;
  }

  step2DataHandler(step2Data: FacilitySummaryObject): void {
    this.step2Info = step2Data;
  }

  cancelSignUpHandler(): void {
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.showUnSavedChangesModal = true;
      this.rootScopeData.pathToNavigate = '/facility/manage'
    } else {
      this.router.navigate(['/facility/manage']);
    }
  }
}
